// assets/ds-overview.js
// Pictoirel Design Studio - All Pages Overview (v3.3)
// Optimised: overlay DOM is created once, grid refreshed on each open.
(function() {
  'use strict';

  var _overlay = null;
  var _grid    = null;
  var _isBuilt = false;

  // ── Styles ─────────────────────────────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = [
    '.ds-overview-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.88);z-index:99999998;display:none;flex-direction:column;align-items:center;padding:24px 32px;overflow-y:auto;}',
    '.ds-overview-overlay.is-open{display:flex;}',
    '.ds-overview-header{width:100%;max-width:1200px;display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;}',
    '.ds-overview-title{color:#fff;font-size:18px;font-weight:800;font-family:"Neue Haas Grotesk",Helvetica,sans-serif;}',
    '.ds-overview-close{background:#333;border:none;color:#fff;padding:8px 16px;border-radius:6px;cursor:pointer;font-size:13px;font-weight:700;}',
    '.ds-overview-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;width:100%;max-width:1200px;}',
    '.ds-overview-item{position:relative;cursor:pointer;border-radius:6px;overflow:hidden;border:3px solid transparent;transition:border-color 0.15s;}',
    '.ds-overview-item:hover{border-color:#d4af37;}',
    '.ds-overview-item.is-active{border-color:#fff;}',
    '.ds-overview-item img{width:100%;display:block;border-radius:3px;object-fit:cover;aspect-ratio:4/3;}',
    '.ds-overview-num{position:absolute;bottom:4px;left:5px;background:rgba(0,0,0,0.6);color:#fff;font-size:10px;font-weight:700;padding:2px 6px;border-radius:3px;}',
    '.ds-overview-item[draggable]:hover .ds-overview-num{background:rgba(212,175,55,0.85);}'
  ].join('');
  document.head.appendChild(style);

  // ── Build the overlay once ─────────────────────────────────────────────────
  function ensureOverlayBuilt() {
    if (_isBuilt) return;
    _overlay = document.createElement('div');
    _overlay.className = 'ds-overview-overlay';
    _overlay.id = 'ds-overview-overlay';

    var header = document.createElement('div');
    header.className = 'ds-overview-header';
    var title = document.createElement('div');
    title.className = 'ds-overview-title';
    title.textContent = 'All Spreads';
    var close = document.createElement('button');
    close.className = 'ds-overview-close';
    close.textContent = '✕ Close';
    close.onclick = closeOverlay;
    header.appendChild(title);
    header.appendChild(close);
    _overlay.appendChild(header);

    _grid = document.createElement('div');
    _grid.className = 'ds-overview-grid';
    _overlay.appendChild(_grid);
    document.body.appendChild(_overlay);

    _overlay.addEventListener('click', function(e) {
      if (e.target === _overlay) closeOverlay();
    });

    _isBuilt = true;
  }

  // ── Refresh the grid with current spread data ─────────────────────────────
  function refreshGrid() {
    _grid.innerHTML = '';
    var spreads = window.spreadMemory || [];
    for (var i = 0; i < spreads.length; i++) {
      renderSpreadThumb(spreads[i], i);
    }
  }

  function renderSpreadThumb(spread, idx) {
    var item = document.createElement('div');
    item.className = 'ds-overview-item' + (idx === window.currentSpreadIndex ? ' is-active' : '');
    item.dataset.idx = idx;
    item.draggable = true;

    var thumbImg = document.createElement('img');
    thumbImg.alt = 'Spread ' + (idx + 1);
    if (window._thumbCache && window._thumbCache[idx]) {
      thumbImg.src = window._thumbCache[idx];
    } else {
      var _bgColor = (spread && spread.paperColor) || '#ffffff';
      thumbImg.src = 'data:image/svg+xml,' + encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="120" height="90"><rect width="120" height="90" fill="' + _bgColor + '"/></svg>'
      );
    }
    item.appendChild(thumbImg);

    var num = document.createElement('div');
    num.className = 'ds-overview-num';
    num.textContent = String(idx + 1);
    item.appendChild(num);

    item.onclick = function() {
      if (window.goToSpread) window.goToSpread(idx);
      else {
          window.currentSpreadIndex = idx;
          if (window.updateNavUI) window.updateNavUI();
          if (window.loadSpreadFromMemoryData) window.loadSpreadFromMemoryData(window.spreadMemory[idx] || { objects: [], paperColor: '#ffffff' });
      }
      closeOverlay();
    };

    var dragFrom = null;
    item.ondragstart = function(e) {
      dragFrom = idx;
      e.dataTransfer.setData('ov-idx', String(idx));
    };
    item.ondragover = function(e) { e.preventDefault(); item.style.opacity = '0.5'; };
    item.ondragleave = function() { item.style.opacity = ''; };
    item.ondrop = function(e) {
      item.style.opacity = '';
      var from = parseInt(e.dataTransfer.getData('ov-idx'));
      var to = idx;
      if (from === to || isNaN(from)) return;
      var moved = window.spreadMemory.splice(from, 1)[0];
      window.spreadMemory.splice(to, 0, moved);
      if (Array.isArray(window._thumbCache)) {
        var movedThumb = window._thumbCache.splice(from, 1)[0];
        window._thumbCache.splice(to, 0, movedThumb);
      }
      window.currentSpreadIndex = to;
      if (window.loadSpreadFromMemoryData) window.loadSpreadFromMemoryData(window.spreadMemory[to]);
      if (window.updateThumbStrip) window.updateThumbStrip();
      closeOverlay();
    };

    _grid.appendChild(item);
  }

  // ── Close ─────────────────────────────────────────────────────────────────
  var _escAttached = false;

  function closeOverlay() {
    if (_overlay) _overlay.classList.remove('is-open');
    document.removeEventListener('keydown', onEsc);
    _escAttached = false;
  }

  function onEsc(e) {
    if (e.key === 'Escape') closeOverlay();
  }

  // ── Public API ────────────────────────────────────────────────────────────
  window.openAllPages = function() {
    ensureOverlayBuilt();
    refreshGrid();
    _overlay.classList.add('is-open');
    if (!_escAttached) {
      document.addEventListener('keydown', onEsc);
      _escAttached = true;
    }
  };

  window.refreshOverviewIfOpen = function() {
    if (_overlay && _overlay.classList.contains('is-open')) refreshGrid();
  };

})();
